import axios from 'axios'
import getCompanies from '../modules/getCompanies'

/**
 * Gets all companies from backend API that the authenticated admin has access to.
 */
export default function getAdminCompanies ({ commit, state }) {
  axios.get(`${process.env.VUE_APP_API_URL}api/companies`, {
    headers: {
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      commit('updateCompanies', getCompanies(response.data.data))
    })
    .catch(function (error) {
      console.log(error)
    })
}
